import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { GridRowSelectionModel } from "@mui/x-data-grid";
import { Button } from "@mui/material";

import { IBlackUser } from "./interfaces";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { blackUsersColumns } from "./components/blackUsersColumns";
import { blackUsersSearchFields } from "./components/blackUsersSearchFields";
import { axiosInstance } from "functions";

export const BlackUserList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IBlackUser>({
            initialCurrent: 1,
            initialPageSize: 20,
        });

    const [rowSelectionModel, setRowSelectionModel] =
        React.useState<GridRowSelectionModel>([]);

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    // 로딩이 아닐 때의 마지막 값을 유지해 표시한다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    // 선택된 사용자 일괄 중단 해제 (현행 로직 유지)
    const unblockUser = async (ids: any) => {
        if (ids.length === 0) {
            window.alert("선택된 사용자가 없습니다.");
            return;
        }

        const unblockPromises = ids.map(async (id: any) => {
            axiosInstance.delete(`${process.env.REACT_APP_IP_ADDRESS}/admin-unblock/${id}`)
        });

        await Promise.all(unblockPromises)
                .then(() => {
                    window.alert("중단 해제 되었습니다.");
                })
                .catch(() => {
                    window.alert("중단 해제에 실패했습니다.");
                });

        window.location.reload();
    };

    return (
        <List
            breadcrumb={<></>}
            headerButtons={({ defaultButtons }) => (
                <>
                    {defaultButtons}
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={() => {
                            unblockUser(rowSelectionModel);
                        }}
                    >
                        중단 해제
                    </Button>
                </>
            )}
        >
            <ListPageHeader
                count={lastRowCountRef.current}
                description="이용이 제한된 회원 목록"
            />

            <SearchToolbar
                fields={blackUsersSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={blackUsersColumns}
                isError={tableQueryResult.isError}
                errorMessage="제한 회원 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 제한 회원이 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
                checkboxSelection
                onRowSelectionModelChange={(model) => setRowSelectionModel(model)}
                rowSelectionModel={rowSelectionModel}
                getRowShowPath={(row) => `/blackUsers/show/${row.id}`}
            />
        </List>
    );
};
